import { FC, useCallback } from 'react';

import { OutlookMessage } from 'utils/types';
import { useOutlookBulkMarkThreadAsRead } from 'modules/account/inbox/hooks';

import SimpleEmailEntry from './SimpleEmailEntry';

type OutlookEntryProps = {
  data: OutlookMessage & {
    selectedEmailAddress: string;
    source: string;
    type: string;
  };
  onClick?: () => void;
};

const OutlookEntry: FC<OutlookEntryProps> = ({ data, onClick }) => {
  const {
    isRead,
    subject,
    bodyPreview: snippet,
    receivedDateTime: date,
  } = data;

  const { mutate: markAsRead } = useOutlookBulkMarkThreadAsRead();

  const _onClick = useCallback(() => {
    onClick?.();
    if (!isRead) {
      markAsRead({ from: data.selectedEmailAddress, messageIds: [data.id] });
    }
  }, [data, isRead, markAsRead, onClick]);

  return (
    <SimpleEmailEntry
      isUnread={!isRead}
      isLoading={false}
      date={date}
      subject={subject ?? 'No Subject'}
      onClick={_onClick}
      snippet={snippet}
    />
  );
};

export default OutlookEntry;
